import { useEffect, useState } from 'react'

import {
  SessionStatus,
  SubEventStatus,
  SubEventsBase,
  SubEventType,
  BlankEnum,
} from '../../../../../types'
import { ModifyEventSchema } from '../../../../events/Events.schema'
import {
  SubEventBaseSchema,
  WelcomeSubEventSchema,
  BreakSubEventSchema,
  PresentationSubEventSchema,
  WorkShopSubEventSchema,
  HotelSubEventSchema,
  MealSubEventSchema,
  MeetingSubEventSchema,
  ThesisPresentationSubEventSchema,
} from '../../../../events/Events.schema'

type SubEvent = ModifyEventSchema['subEvents'][number]
export const defaultSubEvent = (event: number, sessions = [] as number[]): SubEvent => ({
  id: -1,
  status: SubEventStatus.Confirmed,
  name: '',
  description: '',
  comment: '',
  sub_event_type: '' as unknown as SubEvent['sub_event_type'],
  rooms: [],
  start: '',
  end: '',
  sessions,
  tags: [],
  location: null,
  event,
  contributors: [],
  hide_from_generic_program: false,
  _new: true,
})

type Session = ModifyEventSchema['sessions'][number]
export const defaultSession = (event: number): Session => ({
  id: -1,
  name: '',
  start: '',
  end: '',
  short_name: '',
  color: '#9b9b9b',
  event,
  status: SessionStatus.Confirmed,
  type: BlankEnum.Any,
  organizer: BlankEnum.Any,
  sponsor: '',
  tags: [],
  description: '',
  comment: '',
  contributors: [],
  sub_events: [],
  location: null,
  rooms: [],
  _new: true,
  hide_from_generic_program: false,
  default_abstract_presentation_time: '00:15:00',
  default_abstract_qa_time: '00:00:00',
  _showSubEvents: false,
})

export const computeSubEventId = (subEventId: string | number | null | undefined) =>
  `subEvent-${subEventId}`

export const computeSessionId = (sessionId: string | number | null | undefined) =>
  `session-${sessionId}`

const welcomeSubEventSchemaKeys = WelcomeSubEventSchema.keyof().options
const breakSubEventSchemaKeys = BreakSubEventSchema.keyof().options
const presentationSubEventSchemaKeys = PresentationSubEventSchema.keyof().options
const workShopSubEventSchemaKeys = WorkShopSubEventSchema.keyof().options
const hotelSubEventSchemaKeys = HotelSubEventSchema.keyof().options
const mealSubEventSchemaKeys = MealSubEventSchema.keyof().options
const meetingSubEventSchemaKeys = MeetingSubEventSchema.keyof().options
const thesisPresentationSubEventSchemaKeys = ThesisPresentationSubEventSchema.keyof().options
const defaultSubEventSchemaKeys = SubEventBaseSchema.keyof().options

export const useAcceptedKeysPerSubEventType = (subEventType: SubEvent['sub_event_type']) => {
  const [acceptedKeys, setAcceptedKeys] =
    useState<(keyof SubEventsBase | '_new')[]>(defaultSubEventSchemaKeys)

  useEffect(() => {
    switch (subEventType) {
      case SubEventType.WelcomeSubEvent:
        setAcceptedKeys(welcomeSubEventSchemaKeys)
        break
      case SubEventType.BreakSubEvent:
        setAcceptedKeys(breakSubEventSchemaKeys)
        break
      case SubEventType.PresentationSubEvent:
        setAcceptedKeys(presentationSubEventSchemaKeys)
        break
      case SubEventType.WorkShopSubEvent:
        setAcceptedKeys(workShopSubEventSchemaKeys)
        break
      case SubEventType.HotelSubEvent:
        setAcceptedKeys(hotelSubEventSchemaKeys)
        break
      case SubEventType.MealSubEvent:
        setAcceptedKeys(mealSubEventSchemaKeys)
        break
      case SubEventType.MeetingSubEvent:
        setAcceptedKeys(meetingSubEventSchemaKeys)
        break
      case SubEventType.ThesisPresentationSubEvent:
        setAcceptedKeys(thesisPresentationSubEventSchemaKeys)
        break
      default:
        setAcceptedKeys(defaultSubEventSchemaKeys)
        break
    }
  }, [subEventType])

  return acceptedKeys
}
